export const validIsp = (isp) => {
  return !isp.is_private && !isp.not_enough_data;
}

const findStatGroup = (list, timeWindow) => {
  const options = list.filter((s) => s.window_size === timeWindow)
  if (options.length > 0) {
    return options[0]
  } else {
    return list[0]
  }
}

export const sortIsps = (isps, timeWindow = 0, sortBy = 'connection_score') => {
	return isps.slice().sort((aList, bList) => {
    const a = findStatGroup(aList.stats, timeWindow)
    const b = findStatGroup(bList.stats, timeWindow)
		if(sortBy === 'connection_score') {
			const aStats = a.stats_ethernet ? a.stats_ethernet : a.stats_overall;
		  const bStats = b.stats_ethernet ? b.stats_ethernet : b.stats_overall;

		  if (aStats[sortBy] !== bStats[sortBy]) { //simple numeric
		    return aStats[sortBy] > bStats[sortBy] ? -1 : 1;
		  } else if (a.stats_overall[sortBy] !== b.stats_overall[sortBy]) { // fall back to overall if ethernet is equal.
		    return a.stats_overall[sortBy] > b.stats_overall[sortBy] ? -1 : 1;
		  } else { // fall back to name.
		    return aList.name < bList.name ? -1 : 1;
		  }
		} else {
			if (a.stats_overall[sortBy] !== b.stats_overall[sortBy]) { //simple numeric
	      return a.stats_overall[sortBy] > b.stats_overall[sortBy] ? -1 : 1;
	    } else { // fall back to name.
	      return aList.name < bList.name ? -1 : 1;
	    }
		}
	});
}



// WEBPACK FOOTER //
// ./src/store/reducers/utils.js